import React, { useEffect } from "react";
import './News.css';

const News = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top-left corner
  }, []); // Empty dependency array ensures it runs only once on mount

  return (
    <div className="news-page">
      <div className="container">
        <h1>Company News</h1>
        
        {/* Logo Watermark */}
        <div className="logo-watermark">
          <img src="/logo.png" alt="Zenith World Wide Logo" className="watermark-logo" />
        </div>
        
        <section className="news-hero">
          <h2>Stay Updated with Zenith World Wide</h2>
          <p>Keep up with our latest announcements, achievements, and industry insights.</p>
        </section>

        <section className="featured-news">
          <h2>Featured News</h2>
          <div className="news-article featured">
            <div className="news-meta">
              <span className="news-date">October 1, 2025</span>
              <span className="news-category">Company Expansion</span>
            </div>
            <h3>Zenith World Wide Expands Global Operations with New Offices in Asia-Pacific</h3>
            <p>We're excited to announce the opening of new regional offices in Singapore, Tokyo, and Sydney. This expansion strengthens our presence in the Asia-Pacific market and allows us to better serve our growing client base in the region.</p>
            <p>The new offices will house our regional teams specializing in technology consulting, software development, and customer support. This strategic move reflects our commitment to providing localized services and building stronger relationships with our Asia-Pacific partners.</p>
            <a href="#" className="read-more">Read Full Article</a>
          </div>
        </section>

        <section className="news-grid">
          <h2>Recent News</h2>
          <div className="news-articles">
            <article className="news-article">
              <div className="news-meta">
                <span className="news-date">March 10, 2024</span>
                <span className="news-category">Product Launch</span>
              </div>
              <h3>New Product Launch: Zenith Analytics Platform 2.0</h3>
              <p>Introducing our latest version of the Zenith Analytics Platform with enhanced AI capabilities, improved data visualization, and advanced predictive analytics features.</p>
              <a href="#" className="read-more">Read More</a>
            </article>

            <article className="news-article">
              <div className="news-meta">
                <span className="news-date">March 5, 2024</span>
                <span className="news-category">Awards</span>
              </div>
              <h3>Zenith World Wide Wins "Best Technology Innovation" Award</h3>
              <p>We're honored to receive the "Best Technology Innovation" award at the Global Tech Excellence Awards 2024 for our groundbreaking work in AI-powered business solutions.</p>
              <a href="#" className="read-more">Read More</a>
            </article>

            <article className="news-article">
              <div className="news-meta">
                <span className="news-date">February 28, 2024</span>
                <span className="news-category">Partnership</span>
              </div>
              <h3>Strategic Partnership with Leading Cloud Provider</h3>
              <p>We've announced a strategic partnership with a major cloud provider to enhance our cloud solutions and offer more comprehensive services to our clients.</p>
              <a href="#" className="read-more">Read More</a>
            </article>

            <article className="news-article">
              <div className="news-meta">
                <span className="news-date">February 20, 2024</span>
                <span className="news-category">Sustainability</span>
              </div>
              <h3>Zenith World Wide Commits to Carbon Neutral Operations by 2025</h3>
              <p>As part of our commitment to environmental responsibility, we're implementing comprehensive sustainability initiatives to achieve carbon neutral operations by 2025.</p>
              <a href="#" className="read-more">Read More</a>
            </article>

            <article className="news-article">
              <div className="news-meta">
                <span className="news-date">February 15, 2024</span>
                <span className="news-category">Industry Insights</span>
              </div>
              <h3>Industry Report: The Future of Digital Transformation in 2024</h3>
              <p>Our latest industry report explores emerging trends in digital transformation and provides insights for businesses looking to stay competitive in the digital age.</p>
              <a href="#" className="read-more">Read More</a>
            </article>

            <article className="news-article">
              <div className="news-meta">
                <span className="news-date">February 10, 2024</span>
                <span className="news-category">Community</span>
              </div>
              <h3>Zenith World Wide Sponsors Local Tech Education Initiative</h3>
              <p>We're proud to sponsor a local initiative that provides technology education and mentorship opportunities to underserved communities.</p>
              <a href="#" className="read-more">Read More</a>
            </article>
          </div>
        </section>

        <section className="newsletter-signup">
          <h2>Stay Informed</h2>
          <p>Subscribe to our newsletter to receive the latest news and updates directly in your inbox.</p>
          <div className="newsletter-form">
            <input type="email" placeholder="Enter your email address" className="email-input" />
            <button className="subscribe-button">Subscribe</button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default News;
